export const MODULE_NAME = "companyCredit";

export const CREDIT_STATUS_APPROVED='Approved'
export const CREDIT_STATUS_REJECTED='Rejected'
export const CREDIT_STATUS_PENDING='Pending'